/** How long the object URL outlives the click. Firefox and Safari read it after click() returns. */
export const OBJECT_URL_REVOKE_DELAY_MS = 1000;

/**
 * Saves a downloaded file in the browser. The object URL is revoked after a short delay:
 * revoking it right after click() can cancel the download in Firefox and Safari.
 */
export function saveBlobAsFile(blob: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_REVOKE_DELAY_MS);
}
